import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SBUArrayModel,
  SBUModel,
  UserSBUInfoModel,
} from "../../models/SBUModel";

const initialSBUState: SBUArrayModel = {
  all_SBUs: [],
  particular_SBU: {
    sbuid: 0,
    name: "",
    sbuuserId: 0,
    description: "",
    isActive: false,
  },
  userSBUs: [],
  particularUserSBU: {
    sbuid: 0,
    sbuName: "",
    sbuUserID: 0,
    sbuUserName: "",
    sbgid: 0,
    sbgName: "",
    sbgUserID: 0,
    sbgUserName: "",
    csgoid: 0,
    csgoName: "",
    csgoUserID: 0,
    csgoUserName: "",
  },
  isSbusFetching: false,
};
const SBUSlice = createSlice({
  name: "SBU",
  initialState: initialSBUState,
  reducers: {
    setSBUs(state, action: PayloadAction<SBUModel[]>) {
      state.all_SBUs = action.payload;
    },
    setParticularSBU(state, action: PayloadAction<SBUModel>) {
      state.particular_SBU = action.payload;
    },
    setUserSBUs(state, action: PayloadAction<UserSBUInfoModel[]>) {
      state.userSBUs = action.payload;
    },
    setParticularUserSBU(state, action: PayloadAction<UserSBUInfoModel>) {
      state.particularUserSBU = action.payload;
    },
    resetParticularUserSBU(state) {
      state.particularUserSBU = initialSBUState.particularUserSBU;
    },
    setIsSbusFetching(state, action: PayloadAction<boolean>) {
      state.isSbusFetching = action.payload;
    },
  },
});
export default SBUSlice;
